import { useAtomValue } from "jotai";
import type { JSX } from "react";

import { useField } from "@frontend/hooks/form";
import { ReferenceField } from "@frontend/shared/reference-field";
import { useLingui } from "@lingui/react/macro";

import { useSubTaskTypes } from "../hooks/useSubTaskTypes";
import { projectForm } from "../stores/editor";

const fields = projectForm.fields.intervention.fields;

/** The sub types on offer are those of the task type above it. */
export function SubTaskTypeField(): JSX.Element {
  const { t } = useLingui();

  const taskTypeId = useAtomValue(fields.taskTypeId.atom);
  const subTaskTypes = useSubTaskTypes(taskTypeId ?? null);

  useField(fields.subTaskTypeId);

  return (
    <ReferenceField
      label={t`Sub task type`}
      placeholder={t`Please choose an option`}
      items={subTaskTypes}
      field={fields.subTaskTypeId}
      disabled={null == taskTypeId}
    />
  );
}
